module.exports = __webpack_public_path__ + "img/raviosoft_logo.8cd4c0d0.svg";